module.exports = __webpack_public_path__ + "static/media/8.70ade32a.jpg";